// extracted by mini-css-extract-plugin
module.exports = {"tag":"MicroTag_tag__2iMFc","text":"MicroTag_text__1K3D0"};